import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../../../employee/service/web.service';

@Injectable()
export class DiagnosticService extends WebService {

    public getDiagnostic (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[], _with?: string,_with_count?: string): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        if (_with !== null && _with !== undefined) {
            params.append('_with', _with);
        }
        if (_with_count !== null && _with_count !== undefined) {
            params.append('_with_count', _with_count);
        }

        const options = new RequestOptions({search: params, headers:this.headers});

        return this.http.get( `${this.apiUrl}/diagnostics?${params}`, options);
    }

    public getDiagnosticByEducation (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        // params.append('_with', String(''));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/diagnostics-search?${params}`, options);
    }

    public getDiagnosticByWorkExperience (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('diagnostic.education,diagnostic.work_experience,diagnostic.diagnostic_comment'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/diagnostics-search?${params}`, options);
    }
    public getDiagnosticLow (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[], _with?: string): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        if (_with !== null && _with !== undefined) {
            params.append('_with', _with);
        }

        const options = new RequestOptions({search: params, headers:this.headers});

        return this.http.get( `${this.apiUrl}/diagnostics-low?${params}`, options);
    }

    public newDiagnostic(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/diagnostics`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateDiagnostic(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/diagnostics/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteDiagnostic(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/diagnostics/${id}`, { headers: this.headers } );
    }

    public viewDiagnostic(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('_with', String('citation.document_profile_survey,citation.requisition_diagnostic.company,citation.requisition_diagnostic.profile_survey,citation.requisition_diagnostic.venue'));
        return this.http.get( `${this.apiUrl}/diagnostics/${id}?${params}`,  { headers: this.headers } );
    }
    public infoDiagnostic(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('_with', String('created_by,contacts_diagnostic,work_experience'));
        return this.http.get( `${this.apiUrl}/diagnostics/${id}?${params}`,  { headers: this.headers } );
    }

    public infoDiagnosticRelations(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('_with', String('created_by,height,profession_r,residence_country_r,residence_department_r,residence_city_r,birth_country_r,birth_department_r,birth_city_r,expedition_city_r'));
        return this.http.get( `${this.apiUrl}/diagnostics/${id}?${params}`,  { headers: this.headers } );
    }

    public infoDiagnosticSmall(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/diagnostics/${id}?`,  { headers: this.headers } );
    }

    public getDocumentHV(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/hojasdevidas/${id}/files`,  { headers: this.headers } );
    }

    public sorttimeDiagnostic(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/diagnostics-sorttime`, JSON.stringify(body) , { headers: this.headers } );
    }

    public getDocumentsDiagnostic(diagnostic_id: number){
        return this.http.get( `${this.apiUrl}/documents-diagnostic?diagnostic_id=${diagnostic_id}`,  { headers: this.headers } );
    }
    public getDocumentsDiagnosticEmployee(diagnostic_id: number){
        return this.http.get( `${this.apiUrl}/documents-diagnostic/employee?diagnostic_id=${diagnostic_id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/custom-autocomplete/service/diagnostic/diagnostic.service.ts